import { useState } from "react";

import { dispatch } from "../../state/store";
import { pushCreatedTableRowsIds, setNotificationCampaignsRefresh } from "../../state/ducks";

import { strCode } from "../../consts";
import { log, notificationCampaignsService, notificationService, t } from "../../services";
import { responseUtil } from "../../utils";
import { parseErrorMessage } from "../fwuCampaigns/useCreateFWUCampaign";

export const useCreateNotificationCampaign = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  const mutationCallback = async (campaign) => {
    try {
      setLoading(true);
      setError(false);

      const res = await notificationCampaignsService.createCampaign(campaign);

      if (responseUtil.isResponseSuccessful(res)) {
        notificationService.showSuccess({
          title: t(strCode.CREATE_CAMPAIGN_SUCCESS),
          message: t(strCode.CREATE_CAMPAIGN_SUCCESS_INFO, {
            name: campaign?.campaignName
          })
        });

        dispatch(pushCreatedTableRowsIds([res?.data?.data.campaignName]));
        dispatch(setNotificationCampaignsRefresh(true));
      }
    } catch (err) {
      setError(true);

      log.error("useCreateNotificationCampaign: Failed to create notification campaign", err);

      notificationService.showError({
        title: t(strCode.CREATE_NOTIFICATION_CAMPAIGN_ERROR),
        message: t(parseErrorMessage(err))
      });
    } finally {
      setLoading(false);
    }
  };

  return { mutationCallback, loading, error };
};
